var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-container"},[_c('transition-group',{staticClass:"tabs",attrs:{"tag":"div","name":"tab"}},[(_vm.currentTab === 'media')?_c('media-container',{key:"media"}):_vm._e(),_vm._v(" "),(_vm.currentTab === 'website')?_c('website-container',{key:"website"}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-336e8186","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TabContainer.vue
// module id = 524
// module chunks = 1